export default __webpack_public_path__ + "static/media/codigo-de-barras.d8bba2a2.svg";